namespace TabAurous.Production {
    export interface WIPMovementRow {
        MovementId?: number;
        RefMovementId?: number;
        TransId?: number;
        TransDate?: string;
        MovementDate?: string;
        RefTransId?: number;
        TransItemId?: number;
        RefTransItemId?: number;
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        RefVoucherId?: number;
        OrderTypeId?: number;
        OrderId?: number;
        OrderVoucherNo?: string;
        PartyId?: number;
        CustomerName?: string;
        ProductId?: number;
        ProductCode?: string;
        ItemTypeId?: number;
        CalcOnId?: number;
        HasBom?: boolean;
        AttributeId?: number;
        Attribute?: string;
        DepartmentId?: number;
        ProcessId?: number;
        EmployeeId?: number;
        EmployeeName?: string;
        DeptCode?: string;
        DeptName?: string;
        BagNo?: string;
        SubBagNo?: number;
        Line_No?: number;
        SKU?: string;
        Parts?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Purity?: number;
        PureWeight?: number;
        Loss?: number;
        LossPercent?: number;
        ImageName?: string;
        FinancialYearId?: number;
        CompanyId?: number;
        OrderPiece?: number;
        ProcessName?: string;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        FromDepartmentId?: number;
        ToDepartmentId?: number;
        FromDeptName?: string;
        ToDeptName?: string;
        FromPieces?: number;
        ToPieces?: number;
        FromWeight?: number;
        ToWeight?: number;
        FromNetWeight?: number;
        ToNetWeight?: number;
        FromEmployeeId?: number;
        ToEmployeeId?: number;
        FromEmployeeName?: string;
        ToEmployeeName?: string;
    }

    export namespace WIPMovementRow {
        export const idProperty = 'MovementId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.WIPMovement';
        export const lookupKey = '*';

        export function getLookup(): Q.Lookup<WIPMovementRow> {
            return Q.getLookup<WIPMovementRow>('*');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            MovementId = "MovementId",
            RefMovementId = "RefMovementId",
            TransId = "TransId",
            TransDate = "TransDate",
            MovementDate = "MovementDate",
            RefTransId = "RefTransId",
            TransItemId = "TransItemId",
            RefTransItemId = "RefTransItemId",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            RefVoucherId = "RefVoucherId",
            OrderTypeId = "OrderTypeId",
            OrderId = "OrderId",
            OrderVoucherNo = "OrderVoucherNo",
            PartyId = "PartyId",
            CustomerName = "CustomerName",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ItemTypeId = "ItemTypeId",
            CalcOnId = "CalcOnId",
            HasBom = "HasBom",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            EmployeeId = "EmployeeId",
            EmployeeName = "EmployeeName",
            DeptCode = "DeptCode",
            DeptName = "DeptName",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            Line_No = "Line_No",
            SKU = "SKU",
            Parts = "Parts",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Loss = "Loss",
            LossPercent = "LossPercent",
            ImageName = "ImageName",
            FinancialYearId = "FinancialYearId",
            CompanyId = "CompanyId",
            OrderPiece = "OrderPiece",
            ProcessName = "ProcessName",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            FromDepartmentId = "FromDepartmentId",
            ToDepartmentId = "ToDepartmentId",
            FromDeptName = "FromDeptName",
            ToDeptName = "ToDeptName",
            FromPieces = "FromPieces",
            ToPieces = "ToPieces",
            FromWeight = "FromWeight",
            ToWeight = "ToWeight",
            FromNetWeight = "FromNetWeight",
            ToNetWeight = "ToNetWeight",
            FromEmployeeId = "FromEmployeeId",
            ToEmployeeId = "ToEmployeeId",
            FromEmployeeName = "FromEmployeeName",
            ToEmployeeName = "ToEmployeeName"
        }
    }
}
